import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pretty',
    standalone: false
})
export class PrettyPipe implements PipeTransform {
  public transform(value: any): string {
    return value ? JSON.stringify(value, null, 2) : '';
  }
}